export const cvuNumero = (c) => c.numero || c.numero_limpio || c.cvu || '';

// Mismo criterio que el backend (_es_activo): activo=true o estado "Activo".
export const esCvuActivo = (c) => !!c.activo || String(c.estado || '').trim().toLowerCase() === 'activo';

export const sponsorKey = (c) => (c.banco_sponsor ? c.banco_sponsor.prefijo : 'desconocido');
export const sponsorNombre = (c) => (c.banco_sponsor ? c.banco_sponsor.nombre : 'Desconocido');

// [{nombre, cantidad, anterior}] de los CVUs activos, agrupados por banco sponsor.
export const resumenActivos = (cvus = []) => {
  const grupos = {};
  cvus.filter(esCvuActivo).forEach((c) => {
    const k = sponsorKey(c);
    if (!grupos[k]) grupos[k] = { key: k, nombre: sponsorNombre(c), cantidad: 0, anterior: c.banco_sponsor ? !c.banco_sponsor.activo : false };
    grupos[k].cantidad += 1;
  });
  return Object.values(grupos).sort((a, b) => Number(a.anterior) - Number(b.anterior) || b.cantidad - a.cantidad);
};

export const opcionesSponsor = (cvus = []) => {
  const vistos = {};
  cvus.forEach((c) => { vistos[sponsorKey(c)] = sponsorNombre(c); });
  return Object.entries(vistos).map(([value, label]) => ({ value, label }));
};

export const filtrarCvus = (cvus = [], { sponsor = 'todos', estado = 'todos' }) => cvus.filter((c) => (
  (sponsor === 'todos' || sponsorKey(c) === sponsor)
  && (estado === 'todos' || (estado === 'activos' ? esCvuActivo(c) : !esCvuActivo(c)))
));
